import Vue from 'vue';
import App from './App.vue';

import AmapComponent from './components/AmapComponent.vue';
import PageFooter from './components/PageFooter.vue';
import PageHeader from './components/PageHeader.vue';
import router from './router';

import './assets/css/style.css';

// import Vue from 'vue';  
// import ElementUI from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css';
// Vue.use(ElementUI);

import { 
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Carousel,
  CarouselItem,
  Pagination
} from 'element-ui';



Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')

Vue.use(Dropdown);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Carousel);
Vue.use(CarouselItem);
Vue.use(Pagination);
Vue.component('PageFooter', PageFooter); 
Vue.component('PageHeader', PageHeader); 

Vue.component('amap-component', AmapComponent); // 全局注册组件，或在 App.vue 中局部注册    
// new Vue({  
//   render: h => h(App),  
// }).$mount('#app');